export default __webpack_public_path__ + "static/media/element_25.616dc596.webp";